var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3zm0-10C8.1 2 5 5 5 8.8c0 4 4.1 10.3 6 12.8.2.3.6.4 1 .4s.7-.2 1-.4c1.9-2.4 6-8.7 6-12.8 0-1.8-.7-3.6-2-4.8-1.4-1.3-3.2-2-5-2z"
  })));
}

export default SvgMarker;